export const setAawzDrive = ({ commit }, payload) => {
  commit('SET_AAWZ_DRIVE', payload)
}

export const addAawzDrive = ({ commit }, payload) => {
  commit('ADD_AAWZ_DRIVE', payload)
}

export const deleteAawzDrive = ({ commit }, payload) => {
  commit('DELETE_AAWZ_DRIVE', payload)
}

export const renameAawzDriveItem = ({ commit }, payload) => {
  commit('RENAME_AAWZ_DRIVE_ITEM', payload)
}

export const setAawzDriveStorage = ({ commit }, payload) => {
  commit('SET_AAWZ_DRIVE_STORAGE', payload)
}

export const setAawzDriveLoading = ({ commit }, payload) => {
  commit('SET_AAWZ_DRIVE_LOADING', payload)
}

export const setAawzDriveUploadLoading = ({ commit }, payload) => {
  commit('SET_AAWZ_DRIVE_UPLOAD_LOADING', payload)
}

export const setAawzDriveAllowedExtensions = ({ commit }, payload) => {
  commit('SET_AAWZ_DRIVE_ALLOWED_EXTENSIONS', payload)
}
